import React from "react";
import PropTypes from "prop-types";

const CustomSpinner = ({ size = 50, color = "white", borderWidth = 4 }) => {
    const spinnerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        border: `${borderWidth}px solid rgba(115, 115, 115, 0.3)`,
        borderRadius: "50%",
        borderTopColor: color,
        animation: "spin 0.8s linear infinite",
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div style={spinnerStyle}></div>
        </div>
    );
};

CustomSpinner.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    borderWidth: PropTypes.number,
};

export default CustomSpinner;
